import DataGrid, {
    Column, FilterPanel,
    FilterRow,
    HeaderFilter,
    Lookup,
    Pager,
    Paging,
    Selection, Sorting
} from 'devextreme-react/data-grid';
import React, { useMemo, useState } from 'react';
import { Confirm, Modal } from 'semantic-ui-react';
import { formRegisterApi } from '../../../api/formRegisterApi';
import { DefaultButton, PrimaryButton } from '../../../components/editor/button';
import { FormGroup } from '../../../components/form-group';
import { useCommonContext } from '../../../contexts/common';
import { showNotify } from '../../../helpers/toast';
import { useSelector } from 'react-redux';

const SendEmailMoiGhiDanhModal = ({ dm_chiendich_id, dataSource, ts_form_items, onCancel, hanleReloadDataSource, chienDichs }) => {
    const { translate } = useCommonContext();
    const [selectedIds, setSelectedIds] = useState([]);
    const [isShowConfirm, setIsShowConfirm] = useState(false);
    const [isSending, setIsSending] = useState(false);
    const { dm_coso_id } = useSelector(x => x.coSo)

    const isValid = useMemo(() => {
        if (selectedIds.length <= 0) return false;
        return true;
    }, [selectedIds.length])

    const onSendEmailClick = async () => {
        setIsShowConfirm(true)
    }
    const onSendEmailSubmit = async () => {
        setIsSending(true);
        const res = await formRegisterApi.SendEmailMoiGhiDanh({
            ts_register_result_ids: selectedIds,
            dm_chiendich_id,
            dm_coso_id
        });
        setIsSending(false)
        if (res.is_success) {
            showNotify({ text: "Đã gửi thành công", type: "success" });
            hanleReloadDataSource();
            setIsShowConfirm(false)
            onCancel();
        } else {
            showNotify({ text: "Gửi email thất bại", type: "error" })
        }
    }
    return (
        <>
            <Modal open={true} size="large" dimmer={"blurring"} onClose={onCancel}
                closeOnEscape={false}
                closeOnDimmerClick={false}>
                <Modal.Header>
                    <p>{translate('Gửi email mời ghi danh')}</p>
                </Modal.Header>
                <Modal.Content>
                    <form className="ui">
                        <FormGroup label={"Chọn danh sách gửi"}>
                            <DataGrid
                                keyExpr="id"
                                dataSource={dataSource}
                                columnHidingEnabled={false}
                                columnAutoWidth={true}
                                showBorders={true}
                                showColumnLines={false}
                                showRowLines={false}
                                rowAlternationEnabled={true}
                                allowColumnResizing={true}
                                columnResizingMode={'nextColumn'}
                                hoverStateEnabled={true}
                                focusedRowEnabled={false}
                                height={window.innerHeight - 320}
                                className="table-noborder-left"
                                noDataText={translate('Không có dữ liệu')}
                                onSelectionChanged={({ selectedRowKeys }) => setSelectedIds(selectedRowKeys)}

                            >
                                <Column dataField="id" caption={'#Id'} allowEditing={false} width={100}></Column>
                                <Column dataField="is_send_mail_moi_ghi_danh" caption={translate('Đã gửi email')} width={160}></Column>
                                {/* <Column caption={"Data đăng ký"} alignment="center">
                                    {ts_form_items.map((x) => {
                                        return (
                                            <Column
                                                key={x.id}
                                                dataField={`T_${x.id}`}
                                                caption={x.label}
                                                allowEditing={false}
                                            ></Column>
                                        );
                                    })}
                                </Column> */}
                                <Column dataField="dm_chiendich_id" caption={translate('Chiến dịch')} width={150}>
                                    <Lookup dataSource={chienDichs} valueExpr="id" displayExpr={"ten_chien_dich"} />
                                </Column>
                                <Column dataField="phone_number" caption={translate('Điện thoại')} width={100}></Column>
                                <Column dataField="ho_ten" caption={translate('Họ tên')} minWidth={150}></Column>
                                <Column dataField="email" caption={translate('Email')} width={150}></Column>
                                <Column dataField="ho_ten_hoc_sinh" caption={translate('Học sinh')} width={150}></Column>
                                <Column dataField="khoi_lop" caption={translate('Year')} width={100}>
                                </Column>
                                <Sorting mode="multiple" />
                                <Paging defaultPageSize={50} />
                                <Selection mode="multiple"></Selection>
                                <FilterRow visible={true} />
                                <FilterPanel visible={true} />
                                <HeaderFilter visible={true} />
                                <Pager
                                    showPageSizeSelector={true}
                                    allowedPageSizes={[10, 20, 50, 200, 500]}
                                    infoText={`${translate('Trang')} {0} /{1} ({2} ${translate(
                                        'dòng'
                                    )})`}
                                    showInfo={true}
                                />
                            </DataGrid>
                        </FormGroup>
                    </form>
                </Modal.Content>
                <Modal.Actions>
                    <div>
                        <DefaultButton text={"Đóng"} onClick={() => {
                            onCancel();
                        }} />
                        <PrimaryButton text={`Gửi Email (${selectedIds.length})`} disabled={!isValid}
                            onClick={onSendEmailClick}
                        />
                    </div>
                </Modal.Actions>
            </Modal>
            {isShowConfirm &&
                <Confirm
                    open={true}
                    dimmer={'blurring'}
                    header={translate('Lưu ý')}
                    content={translate('Bạn có chắc chắn muốn gửi email mời ghi danh ?')}
                    size="mini"
                    cancelButton={() => {
                        return (
                            <>
                                <DefaultButton text={"Để sau"} onClick={() => {
                                    setIsShowConfirm(false);
                                }} />
                            </>
                        );
                    }}
                    confirmButton={() => {
                        return (
                            <>
                                <PrimaryButton text={"Xác nhận gửi"} icon="fas fa-paper-plan"
                                    isLoading={isSending}
                                    onClick={() => {
                                        onSendEmailSubmit();
                                    }} />
                            </>
                        );
                    }}
                />
            }
        </>
    );
};

export default SendEmailMoiGhiDanhModal;